export const WEB = 'web'
export const APP = 'app'